/*
 * Extends ApplicationId enum which is used for building planning tile template data.
 * Plannings of VirtualPlanningIds do not really exist they are build from miscellenious project data
 * to be presented just like planning tiles in the UI.
 */
export enum VirtualPlanningId {
    ExistingPVandEV = 'EXISTING_PV_AND_EV'
}
